module.exports = __webpack_public_path__ + "img/hplc_logo.82761bcd.png";